export enum FiltersSelectorTypes {
  AppliedFilters = '[Filters] Applied Filters',
  AppliedExtendedFilters = '[Filters] Applied Extended Filters',
  GetSettings = '[Filters] Get Settings',
  ResetFilters = '[Filters] Reset Filters',
}
